import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import Image from 'react-bootstrap/lib/Image';
import classnames from 'classnames';
import {DataDtmActions} from '../Constants';
import Classes from './../Classes';
import bundledAssets from '../../../images/assets.json';
import mixpanelConstants from '../mixpanelConstants';
import {trackImpressions} from '../MixpanelHelper';

const DocumentImage = ({
  src, alt, onClick, imageDataDtm, imageIndex, mixpanelProps
}) => {
  const imageUrl = src
  const clickable = onClick ? Classes.clickable : null;
  const fallbackImage = bundledAssets.defaultDocumentImageUrl;
  const documentRef = useRef();

  let retry = 1;
  const onImageError = ((e) => {
    if (e.target.src === fallbackImage) {
      return;
    }
    if (retry >= 3) {
      e.target.src = fallbackImage;
      return;
    }
    e.target.src = imageUrl;
    retry += 1;
  });


  useEffect(() => {
    const observer = trackImpressions(mixpanelConstants.eventName.documentImpression, mixpanelProps);
    if(documentRef.current){
      observer.observe(documentRef.current)
    }
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className={Classes.relative} ref={documentRef}>
      <Image
        responsive
        className={classnames(Classes.centerBlock, clickable, Classes.documentThumbnail)}
        src={imageUrl}
        alt={alt}
        onClick={(imageIndex || imageIndex === 0) ?  () => onClick(imageIndex) : onClick}
        onError={onImageError}
        data-dtm={imageDataDtm?.tag}
        data-dtm-actions={imageDataDtm ? DataDtmActions.click : null}
        data-dtm-attributes={imageDataDtm?.attributes}
      />
    </div>
  );
};

DocumentImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  onClick: PropTypes.func,
  imageIndex: PropTypes.number,
  mixpanelProps: PropTypes.object
};

export default DocumentImage;
